import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Spinner.css'


export const Spinner = ({message}) => (
  <div style={{ textAlign: 'center' }}>
    <FontAwesomeIcon icon='circle-notch' size='3x' style={{ color: '#050139' }} spin />
    <div>
      <span> {message} </span>
    </div>
  </div>
);

export const SpinnerSmall = ({colour}) => (
  <div style={{ textAlign: 'center' }}>
    <FontAwesomeIcon icon='circle-notch' size='1x' style={{ color: colour }} spin />
  </div>
);